module.exports = __webpack_public_path__ + "media/images/menu/apus-aa7b4558947cf5aec3dec4a173e4f2f2.jpg";